"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeatureSwitches = void 0;
var object_hash_1 = __importDefault(require("object-hash"));
var createFeatureSwitches = function (featureDefaultsByEnvironment, environmentCheckers, config) {
    if (config === void 0) { config = { localStorageKey: "features" }; }
    var featureDefaults;
    if (environmentCheckers.isDev()) {
        featureDefaults = featureDefaultsByEnvironment.dev;
    }
    else if (environmentCheckers.isStaging()) {
        featureDefaults = featureDefaultsByEnvironment.staging;
    }
    else if (environmentCheckers.isProduction()) {
        featureDefaults = featureDefaultsByEnvironment.production;
    }
    else {
        throw new Error("Environment cannot be identified");
    }
    var loadFeatureSwitches = function () {
        if (environmentCheckers.isProduction()) {
            return;
        }
        var newHash = object_hash_1.default(featureDefaults, {
            algorithm: "md5",
            encoding: "base64",
            respectFunctionProperties: false,
            respectType: false,
        });
        var oldHash = localStorage.getItem(config.localStorageKey + "_hash") || "";
        if (oldHash !== newHash) {
            localStorage.setItem(config.localStorageKey, JSON.stringify(featureDefaults));
            localStorage.setItem(config.localStorageKey + "_hash", newHash);
        }
    };
    var featureSwitches = Object.entries(featureDefaults).reduce(function (features, _a) {
        var _b;
        var featureName = _a[0], featureValue = _a[1];
        return (__assign(__assign({}, features), (_b = {}, _b[featureName] = function () {
            if (environmentCheckers.isProduction()) {
                return featureValue;
            }
            var featuresInLocalStorage;
            try {
                featuresInLocalStorage = JSON.parse(localStorage.getItem(config.localStorageKey) || "{}");
            }
            catch (error) {
                featuresInLocalStorage = {};
            }
            return typeof featuresInLocalStorage[featureName] !== "undefined"
                ? featuresInLocalStorage[featureName]
                : featureValue;
        }, _b)));
    }, {});
    var updateFeatureSwitchValue = function (key, value, reload) {
        if (reload === void 0) { reload = true; }
        if (environmentCheckers.isProduction()) {
            return;
        }
        var featuresInLocalStorage = JSON.parse(localStorage.getItem(config.localStorageKey) || "{}");
        featuresInLocalStorage[key] = value;
        localStorage.setItem(config.localStorageKey, JSON.stringify(featuresInLocalStorage));
        if (reload)
            location.reload();
    };
    var updateAllFeatureSwitches = function (featureSwitches, reload) {
        if (reload === void 0) { reload = true; }
        if (environmentCheckers.isProduction()) {
            return;
        }
        localStorage.setItem(config.localStorageKey, JSON.stringify(featureSwitches));
        if (reload)
            location.reload();
    };
    return {
        featureSwitches: featureSwitches,
        updateFeatureSwitchValue: updateFeatureSwitchValue,
        loadFeatureSwitches: loadFeatureSwitches,
        updateAllFeatureSwitches: updateAllFeatureSwitches,
    };
};
exports.createFeatureSwitches = createFeatureSwitches;
